import Grid from "@material-ui/core/Grid";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userDetail } from "../../../config/userDetails";
import DropdownOptions from "../../../constants/DropdownOptions";
import {
  userListAction,
  userTypeChangeAction
} from "../../../modules/userManagement/action";
import Dropdown from "../../FormElement/Dropdown";
import SubMenu from "../../private/SubMenu";
import AllUserListTable from "./AllUserListTable";

class UserManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false
    };
  }

  componentWillMount() {
    const { userListAction, selectedUserType } = this.props;
    if (selectedUserType) {
      userListAction(selectedUserType);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.usersList &&
      this.props.usersList !== nextProps.usersList &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
    if (nextProps.SubFarmId && nextProps.SubFarmId !== this.props.SubFarmId) {
      this.props.userListAction(this.props.selectedUserType);
    }
  }

  selectUserType = event => {
    this.props.userTypeChangeAction(event.target.value);
    this.props.userListAction(event.target.value);
  };

  render() {
    const currentPage = "userManagement";
    const menuName = "User Management";
    const { fetchingComplete } = this.state;
    return (
      <div className="ticket-body">
        <div className="">
          <SubMenu menuName={menuName} />
        </div>
        <Grid
          container
          spacing={25}
          style={{
            paddingTop: "1rem",
            justifyContent: "space-between",
            width: "95%"
          }}
        >
          <Grid item xs={3}>
            <Dropdown
              required
              value={this.props.selectedUserType}
              label="Select User Type"
              type="text"
              name="selectedStatus"
              options={DropdownOptions.ALL_USERS}
              handleChange={this.selectUserType}
              handleError={() => {}}
            />
          </Grid>
        </Grid>
        <div>
          <AllUserListTable
            location={`${currentPage}/edit`}
            changePasswordLocation={`${currentPage}/changepassword`}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    usersList: state.userManagementReducer.usersList,
    selectedUserType: state.userManagementReducer.selectedUserType
  };
}
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      userListAction,
      userTypeChangeAction
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserManagement);



// WEBPACK FOOTER //
// ./src/components/private/UserManagement/UserManagement.js